export default "__VITE_ASSET__DjoSQlSP__"